import { create } from 'zustand';

/**
 * 좌측 NavBar 최하단 "전체메뉴" 패널 열림 상태 — sidebarStore 동형(zustand).
 *
 * 배경: 좌측 메뉴가 세로 배치(아이콘 위 / 라벨 아래, 폭 72px)로 좁아지면서 라벨이 10px 로
 * 줄었다. 그 짝으로 **등록된 모든 메뉴를 넓은 카드 격자로 다시 보여주는** 패널을 최하단
 * 항목에서 연다. 목록 출처는 사이드바와 동일(/menu-config 레지스트리 → NavBar 가 계산한
 * primary/secondary 를 그대로 주입) 이라 두 곳이 갈라지지 않는다.
 *
 * persist 하지 않는다 — 오버레이 패널이라 새로고침 후 열려 있으면 오히려 방해된다.
 * (sidebarStore 의 collapsed 는 선호라 persist, 이쪽은 순간 상태.)
 */
interface AllMenuState {
  open: boolean;
  toggle: () => void;
  setOpen: (open: boolean) => void;
}

export const useAllMenuStore = create<AllMenuState>((set) => ({
  open: false,
  toggle: () => set((s) => ({ open: !s.open })),
  setOpen: (open) => set({ open }),
}));
